import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InlineSVGModule } from 'ng-inline-svg';
import { NgxPopper } from 'angular-popper';
import {
  MatSidenavModule,
  MatMenuModule,
  MatTableModule,
  MatPaginatorModule,
  MatSortModule,
  MatSelectModule,
  MatDialogModule,
} from '@angular/material';
import { NgxSmartModalModule } from 'ngx-smart-modal';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    MatSidenavModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatMenuModule,
    MatSelectModule,
    HttpClientModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    NgxSmartModalModule.forRoot(),
    FormsModule,
    NgxSmartModalModule,
    InlineSVGModule.forRoot(),
    NgxPopper,
  ],
  exports: [
    CommonModule,
    ReactiveFormsModule,
    MatSidenavModule,
    MatMenuModule,
    MatSelectModule,
    MatDialogModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    FormsModule,
    NgxSmartModalModule,
    NgxPopper,
  ],
  entryComponents: [],
})
export class GcvVendorModule {}
